import humanizeDuration from 'humanize-duration';

function formatTime(date) {
  if (date) {
    const difference = (/* @__PURE__ */ new Date()).getTime() - new Date(date).getTime();
    return humanizeDuration(difference, {
      largest: 1,
      round: true
    });
  }
  return "-";
}

export { formatTime };
//# sourceMappingURL=time.esm.js.map
